 import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api/axiosConfig";
import "./AdminLogin.css";
import { FiUser, FiLock, FiArrowRight, FiEye, FiEyeOff } from "react-icons/fi";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const validateForm = () => {
    // ... (validation logic remains the same)
    if (!username.trim()) {
      setError("Username is required.");
      return false;
    }
    if (!password) {
      setError("Password is required.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    // ... (submit logic remains the same)
    e.preventDefault();
    setError("");

    if (!validateForm()) return;

    setIsLoading(true);
    try {
      const response = await api.post("/api/auth/admin/login", {
        username,
        password,
      });

      // Set admin token (allow concurrent logins)
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminRole", response.data.role);
      localStorage.setItem("adminName", response.data.name);

      navigate("/admin-dashboard");
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Invalid credentials or server error.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-card">
        <div className="login-card-header">
          <h2 id="login-title">Admin Portal Login</h2>
          <p>Please enter your administrator credentials</p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          {/* ... (form inputs remain the same) ... */}
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <div className="input-wrapper">
              <FiUser className="input-icon" />
              <input
                id="username"
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <FiLock className="input-icon" />
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            <FiArrowRight /> {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* ======================================================= */}
        {/* ============== FIX: ADDED LOGIN AS USER LINK ============== */}
        {/* ======================================================= */}
        <div className="footer-links-container">
          <Link className="footer-link" to="/admin-forgot-password">
            Forgot Password?
          </Link>
          <Link className="footer-link" to="/user-login">
            Login as User
          </Link>
        </div>
        {/* ======================================================= */}
      </div>
    </div>
  );
};

export default AdminLogin;


